/* LUVF quick add - the + button on the menu/shop grid cards.
   [stated] Anas, 22 Aug 2026: "a PLUS icon in the corner of the photo as an
   ADD TO CART button without it opening a cart pop up just add it to cart",
   like nabat.co.

   So this posts to /cart/add.js directly and refreshes ONLY the header cart
   bubble through the Section Rendering API. It never opens the cart drawer
   or Dawn's cart-notification popup - that is the whole point of the
   request.

   The button is a span with role=button (see the CSS header for why), so
   Enter and Space have to be wired by hand. Markup lives in
   snippets/luvf-menu-card.liquid. The listener is delegated and attached in
   the CAPTURE phase because the button sits inside the card's <a>:
   capturing lets us stop the click before the anchor navigates.

   ============================================================
   25 Aug 2026 - THE DELIVERY DATE IS STAMPED HERE. IT HAS TO BE.
   ============================================================
   For a month this file added dishes to the cart with NO delivery date on
   them at all. Not the wrong date - none. Audited by adding a real dish and
   reading /cart.js back: properties {}, attributes {}, note "".

   TWO separate bugs caused it, either one enough on its own:

     1. sections/luvf-menu-nav.liquid stamped by looking for elements
        matching [data-luvf-weekly]. Counted in the live DOM: ZERO. The
        panels are marked data-lm-weekly. It targeted an attribute that was
        never rendered anywhere, so it never fired once.

     2. Even with the right selector it could not have worked. It appended
        a hidden <input> to a form[action="/cart/add"]. THERE IS NO FORM on
        these cards - the + is a <span> and this file posts JSON.

   So the stamp lives HERE, in the request that actually creates the line.
   If you move the add to a form one day, move the stamp with it.

   ============================================================
   TWO PROPERTIES, AND THEY DO DIFFERENT JOBS
   ============================================================
     "Delivery"        "Monday 31 August"   VISIBLE. This is the only thing
                       that carries the date into Shopify's own checkout
                       page, which the theme cannot otherwise touch.
                       [stated] Anas: "make sure the customer understands
                       when paying." No leading underscore, on purpose -
                       Shopify hides properties whose name starts with "_"
                       from the customer, so renaming it to _Delivery would
                       silently remove the date from checkout.

     "_delivery_date"  "2026-08-31"         HIDDEN, for machines. Added for
                       the kitchen app. Prose is not parseable: "Monday 31
                       August" carries a weekday, no year, and a locale's
                       opinion. Anything that COMPARES dates - the cart's
                       stale-line repair, the Flow that flags a mismatch,
                       the app - reads this one. Nothing ever parses the
                       prose.

   Both come from the same two integers in snippets/luvf-delivery-cycle,
   never computed separately, so they cannot disagree.

   WHAT DECIDES A DISH. The button's ancestor panel:
   .lm-panel[data-lm-weekly="true"], set per category in
   templates/page.luvf-menu.json. Shop items are in panels without it and
   must NEVER be stamped - they are a different delivery promise entirely
   (2-4 days, any day) and a "Monday 31 August" on a jar of nut butter is a
   lie the customer will hold you to.

   IF THE CYCLE NODE IS MISSING nothing is stamped and the add still
   succeeds: a line with no date is recoverable, a line with the WRONG date
   is not, and refusing the sale over a display bug would be worse.

   THE KITCHEN MUST NOT TRUST EITHER VALUE. Both are written by a browser
   and a tab left open past Saturday midnight sends stale ones. The order's
   created_at is the authority; the Flow tags each order from that. */
(function(){
  if(window.__lmQuickAdd) return; window.__lmQuickAdd = 1;

  var WEEKLY_SEL = '.lm-panel[data-lm-weekly="true"]';

  function cycleNode(){
    return document.getElementById('lvf-cycle') || document.getElementById('lvf-cycle-global');
  }
  function attr(name){
    var n = cycleNode();
    return (n && n.getAttribute(name)) || '';
  }

  function refreshBubble(){
    fetch('/?sections=cart-icon-bubble')
      .then(function(r){ return r.json(); })
      .then(function(s){
        var host = document.getElementById('cart-icon-bubble');
        if(!host || !s['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
        var sec = doc.querySelector('.shopify-section');
        host.innerHTML = sec ? sec.innerHTML : host.innerHTML;
      })
      .catch(function(){});
  }

  function add(b){
    if(b.classList.contains('is-busy') || b.classList.contains('is-done')) return;
    var id = parseInt(b.getAttribute('data-add-id'), 10);
    if(!id) return;
    b.classList.add('is-busy');

    var payload = { id: id, quantity: 1 };

    /* dish, not shop item? then it carries its delivery day into checkout */
    if(b.closest(WEEKLY_SEL)){
      var day = attr('data-mine');
      var iso = attr('data-mine-iso');
      if(day){
        payload.properties = { 'Delivery': day };
        if(iso) payload.properties['_delivery_date'] = iso;
      }
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
    .then(function(){
      b.classList.remove('is-busy');
      b.classList.add('is-done');
      b.setAttribute('aria-label', 'Added to cart');
      refreshBubble();
      document.dispatchEvent(new CustomEvent('luvf:cart-changed'));
      setTimeout(function(){
        b.classList.remove('is-done');
        if(b.dataset.label) b.setAttribute('aria-label', b.dataset.label);
      }, 1700);
    })
    .catch(function(){ b.classList.remove('is-busy'); });
  }

  function hit(e){
    return e.target && e.target.closest ? e.target.closest('.lm-add') : null;
  }

  document.addEventListener('click', function(e){
    var b = hit(e);
    if(!b) return;
    e.preventDefault();
    e.stopPropagation();
    add(b);
  }, true);

  document.addEventListener('keydown', function(e){
    if(e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var b = hit(e);
    if(!b) return;
    e.preventDefault();
    e.stopPropagation();
    add(b);
  }, true);
})();